module.exports = __webpack_public_path__ + "img/02.9e37be4a.png";